import type { PollResultCard } from '@dmp/qqms/types';

export const defaultPollResultCard: PollResultCard = {
    id: '',
    type: 'pollResultCard',
    questionId: '',
    traxexLabel: 'PollResultCard',
    resultsDisplayMode: 'both',
    voteMode: 'unlimited',
};
